module.exports = __webpack_public_path__ + "static/media/icon_undel.cf5ef90f.svg";